export const BRAND = {
  name: "Unity Real Estate",
  tagline: "Warsaw relocation, done right.",
  phone: "+48 786 660 277",
  phoneRaw: "+48786660277",
  whatsapp: "48786660277",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_5f6d72b8-f66d-467b-ab11-d8e557ef4d48/artifacts/fydss6fs_IMG_0692.jpeg",
  languages: ["Turkish", "English", "Azerbaijani", "Polish"],
  email: "",
};

const _px = (id, w = 1000, h = 700) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=${h}&w=${w}`;

export const IMG = {
  hero: "https://images.pexels.com/photos/19957325/pexels-photo-19957325.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  heroVideo: "/api/downloads/media/warsaw_hero.mp4",
  heroPoster: "/api/downloads/media/warsaw_hero_poster.jpg",
  heroVideoMobile: "/api/downloads/media/warsaw_hero_mobile.mp4",
  heroPosterMobile: "/api/downloads/media/warsaw_hero_poster_mobile.jpg",
  interior: _px(7195595),
  documents: _px(7567600),
  handshake: _px(8293654),
  warsaw2:
    "https://images.pexels.com/photos/13861/IMG_3496bfree.jpg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=1000",
  // Gallery — recent homes
  g1: _px(1571460, 900, 1100), // bedroom
  g2: _px(1571468, 900, 700),  // kitchen
  g3: _px(2724749, 900, 1100), // living room modern
  g4: _px(1457842, 900, 700),  // dining
  g5: _px(1643383, 900, 1100), // bright bedroom
  g6: _px(2029694, 900, 700),  // modern living
};

export const waLink = (text = "Hi! I'd like help finding a flat in Warsaw.") =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(text)}`;
